import React, {useEffect, useRef} from 'react';
import {FilterLabels} from '../FilterLabels';
import 'styles/item/FilterDropdown.css';

const FilterDropdown = ({config, toggleConfig, onClose}) => {
    const popupRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const eyeDiv = document.querySelector('.market-header-popup-button-container');
            if (popupRef.current && !popupRef.current.contains(event.target) && !eyeDiv.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    const filterKeys = FilterLabels.getViewFilterLabels();

    return (
        <div className="filter-dropdown" ref={popupRef}>
            <div className="filter-dropdown-content">
                {filterKeys.map((key, index, array) => (
                    <div
                        key={key}
                        className={`show-toggle-button ${config.includes(key) ? 'active' : 'inactive'} ${index === array.length - 1 ? 'last' : ''}`}
                        onClick={() => toggleConfig(key)}
                    >
                        <div className="inner-dropdown-element">
                            {FilterLabels[key].label}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FilterDropdown;
